/**
 *  Trạng thái nộp dự toán đầu năm
 */
export default {
  NotApproved: 1, // Chưa nộp
  WaitApproved: 2, // Chờ kiểm tra
  Approved: 3, // Đã duyệt
  Edit: 4, // Cần sửa
};
